import { keyframes } from '@emotion/react';
import { ToastSize } from './types';
import { text_styles } from '../../foundation';

export const toast_size_css: Record<ToastSize, string> = {
  large: text_styles.Body_14_SemiBold,
  medium: text_styles.Body_13_SemiBold,
};

export const toast_show_animation = keyframes`
  to {
    transform: translateY(-20px);
    opacity: 0;
  }
  from {
    transform: translateY(0);
    opacity: 1;
  }
  `;

export const toast_hide_animation = keyframes`
  to {
    transform: translateY(0);
    opacity: 1;
  }
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  `;
